export default "__VITE_ASSET__QXJ$Br8j__"